export const environment = {
    production: true,
    AUTH_URL: 'https://auth.simadvisory.com/auth',
    CLIENT: "PROD_SPRICED_NRP_Client",
    REALMS: "PROD_SPRICED_NRP",
    URL: 'https://excel-addin.spriced.nrp.simadvisory.com',
}
